/**
 * Photos in a template are shaped by Cloudinary, never by the browser.
 *
 * Every frame asks for exactly its own shape: `cover` crops to fill it, centred
 * on what matters (g_auto finds the subject, g_face a face), and `whole` shrinks
 * without cropping. The <img> then only fills a box of that same shape with
 * object-cover or object-contain, so nothing can come out stretched or squashed.
 */

const DOCUMENT_EXTENSIONS = ["pdf", "doc", "docx", "xls", "xlsx", "ppt", "pptx", "txt", "csv", "zip"];

/** image, video or document -- the same rule the server uses (scrapbook/_shared.py). */
export function attachmentKind(attachment) {
  const name = String(attachment?.original_name || attachment?.url || "").split("?")[0].toLowerCase();
  if (DOCUMENT_EXTENSIONS.includes(name.split(".").pop())) return "document";
  if (attachment?.resource_type === "video") return "video";
  if (attachment?.resource_type === "image") return "image";
  return "document";
}

function transform(url, spec) {
  if (typeof url !== "string" || !url.includes("res.cloudinary.com") || !url.includes("/upload/")) return url;
  return url.replace("/upload/", `/upload/${spec}/`);
}

/** Filled to exactly w x h, centred on the subject ("auto") or a face ("face"). */
export const cover = (url, w, h, gravity = "auto") =>
  transform(url, `c_fill,g_${gravity},w_${w},h_${h},f_auto,q_auto`);

/** The whole photo, no crop, no larger than max on either side. */
export const whole = (url, max = 1000) => transform(url, `c_limit,w_${max},h_${max},f_auto,q_auto`);

/** A PDF's first page as a picture (Cloudinary renders it; checked on this account 2026-09-15). */
export const pdfFirstPage = (url, max = 900) =>
  transform(url, `pg_1,c_limit,w_${max},h_${max},q_auto`).replace(/\.pdf$/i, ".jpg");
